import { default as NumericInputModule, INumericInputModuleOptions } from "./numericInput-module";

export { INumericInputModuleOptions as NumericInputModuleOptions };

export default NumericInputModule;



// WEBPACK FOOTER //
// ./lib/ts/modules/numericInput/index.ts